import { ApiTransport } from "./config/apiTransport";
import {
  NotificationListResponse,
  GetNotificationsResponse,
} from "@root/utils/dtos";
import { ApiResponse } from "@root/utils/dtos";

export class NotificationService {
  private readonly _apiTransport: ApiTransport;

  constructor(sessionCookie?: string) {
    this._apiTransport = new ApiTransport(sessionCookie);
  }

  // Get paginated notifications (includes unreadCount)
  getNotifications = (
    page: number = 1,
    pageSize: number = 20
  ): NotificationListResponse => {
    const params = new URLSearchParams({
      page: page.toString(),
      pageSize: pageSize.toString(),
    });
    return this._apiTransport.get<GetNotificationsResponse>(
      `/api/v1/notifications?${params.toString()}`
    );
  };

  // Mark notification as read
  markAsRead = (notificationId: string): Promise<ApiResponse> =>
    this._apiTransport.put(`/api/v1/notifications/${notificationId}/read`, {});

  // Mark all notifications as read
  markAllAsRead = (): Promise<ApiResponse> =>
    this._apiTransport.put(`/api/v1/notifications/read-all`, {});
}

export const notificationService = new NotificationService();

